import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export function useFetchParentCompanyAttributes(parentCompanyId, isEnabled = true) {
  const { oktaAuth } = useOktaAuth();

  const dataKey = "FetchParentCompanyAttributes";

  async function FetchParentCompanyAttributes() {
    if (!parentCompanyId) {
      return null;
    }

    const accessToken = oktaAuth.getAccessToken();

    var result = await axios
      .get("api/ThirdPartyReceivable/GetAttributesForParentCompany", {
        params: {
          parentCompanyId: parentCompanyId
        },
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error("Error fetching parent company attributes:", error);
        throw new Error(error);
      });

    return result;
  }

  return useQuery({
    queryKey: [dataKey, parentCompanyId],
    queryFn: async () => await FetchParentCompanyAttributes(),
    enabled: isEnabled && !!parentCompanyId,
    refetchOnWindowFocus: false
  });
}